module.exports = __webpack_public_path__ + "static/media/18ECA41.3eef2579.jpg";